import apiClient from '../utils/apiClient';

const base = (facilityId) => `/api/facilities/${facilityId}/reservations`;

const reservationsService = {
  getAll: (facilityId, params) =>
    apiClient.get(`${base(facilityId)}/`, { params }),
  getById: (facilityId, id) => apiClient.get(`${base(facilityId)}/${id}`),
  create: (facilityId, data) => apiClient.post(`${base(facilityId)}/`, data),
  cancel: (facilityId, id) => apiClient.post(`${base(facilityId)}/${id}/cancel`),
  markConverted: (facilityId, id) =>
    apiClient.post(`${base(facilityId)}/${id}/mark-converted`),
};

export default reservationsService;
